/**
 * @generated SignedSource<<6b1d86b7b4e213492f91ea797c7c3ee8>>
 * @relayHash f636d5e85b5e9a800a3fed04bd92a96f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2dc9b6455650f84b59ef904fc9d125506fea290e4471ce311588d93306f2aec0

import type { ConcreteRequest } from 'relay-runtime';
export type tenantContextProviderQuery$variables = {
  hostNames?: ReadonlyArray<string> | null;
};
export type tenantContextProviderQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly activationIdByProduct: {
      readonly active: string | null;
    } | null;
    readonly activationIdByProductJira: {
      readonly active: string | null;
    } | null;
    readonly cloudId: string;
    readonly entitlementInfo: {
      readonly entitlementId: string;
    } | null;
    readonly orgId: string;
  } | null>;
};
export type tenantContextProviderQuery = {
  response: tenantContextProviderQuery$data;
  variables: tenantContextProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hostNames"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "hostNames",
    "variableName": "hostNames"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "cloudId"
},
v3 = {
  "kind": "ScalarField",
  "name": "orgId"
},
v4 = [
  {
    "kind": "ScalarField",
    "name": "active"
  }
],
v5 = {
  "args": [
    {
      "kind": "Literal",
      "name": "product",
      "value": "devai"
    }
  ],
  "concreteType": "TenantContextActivationId",
  "kind": "LinkedField",
  "name": "activationIdByProduct",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": "activationIdByProduct(product:\"devai\")"
},
v6 = [
  {
    "kind": "Literal",
    "name": "hamsProductKey",
    "value": "devai.ondemand"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "entitlementId"
},
v8 = {
  "alias": "activationIdByProductJira",
  "args": [
    {
      "kind": "Literal",
      "name": "product",
      "value": "jira"
    }
  ],
  "concreteType": "TenantContextActivationId",
  "kind": "LinkedField",
  "name": "activationIdByProduct",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": "activationIdByProduct(product:\"jira\")"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "tenantContextProviderQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "concreteType": "TenantContext",
          "kind": "LinkedField",
          "name": "tenantContexts",
          "plural": true,
          "selections": [
            {
              "kind": "RequiredField",
              "field": (v2/*: any*/),
              "action": "THROW"
            },
            {
              "kind": "RequiredField",
              "field": (v3/*: any*/),
              "action": "THROW"
            },
            (v5/*: any*/),
            {
              "args": (v6/*: any*/),
              "kind": "LinkedField",
              "name": "entitlementInfo",
              "plural": false,
              "selections": [
                (v7/*: any*/)
              ],
              "storageKey": "entitlementInfo(hamsProductKey:\"devai.ondemand\")"
            },
            (v8/*: any*/)
          ]
        },
        "action": "THROW"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "tenantContextProviderQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v5/*: any*/),
          {
            "args": (v6/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "__typename"
              },
              (v7/*: any*/)
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"devai.ondemand\")"
          },
          (v8/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "2dc9b6455650f84b59ef904fc9d125506fea290e4471ce311588d93306f2aec0",
    "metadata": {},
    "name": "tenantContextProviderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f157dfd1d60f16833e71aea7f1b5c916";

export default node;
